import request from '../request';

export function getDriverWaterRound(params) {
  return request({
    url: "/driver/water-rounds",
    method: "get",
    params
  })
}

export function showDriverWaterRound(id) {
  return request({
    url: `/driver/water-rounds/${id}`,
    method: "get"
  })
}

export function storeDriverWaterRound(data) {
  return request({
    url: `/driver/water-rounds/${data.id}/finish`,
    method: "post",
    data
  })
}

export function finishDriverWaterRound() {
  return request({
    url: "/driver/water-rounds",
    method: "get",
  })
}

export function updateDriverWaterRound(data) {
  return request({
    url: `/driver/water-rounds/${data.id}`,
    method: "put",
    data
  })
}

export function deleteDriverWaterRound(id) {
  return request({
    url: `/driver/water-rounds/${id}`,
    method: "delete"
  })
}

export function isNotificationMessage(params) {
  return request({
    url: '/dispatcher/get-client-bottle-update-requests',
    method: 'get',
    params
  })
}

export function isPayDebt(data) {
  return request({
    url: '/driver/driver-debt-payment',
    method: 'post',
    data
  })
}

export function isPayStatusDebt(data) {
  return request({
    url: '/driver/round-debt-status',
    method: 'post',
    data
  })
}